// La page profil est passée à React (js/react/ecrans/Profil.jsx).
//
// La fenêtre « Modifier mon profil » a été sortie dans `profil-editer.js` : elle
// reste en HTML, et Paramètres comme la page profil l'appellent de là. On la
// réexporte ici pour ne rien casser chez ceux qui l'importaient d'ici.
//
// Les publications du membre ne sont PAS réécrites : `react/ListePosts.jsx`
// prête un conteneur à la machinerie de `posts.js`, intacte.
//
// L'ancienne version (d'avant React) a été retirée le 20 octobre 2026 —
// archivée hors du dépôt : ~/Desktop/koinonia-archive-code-retire-2026-10-20.zip.
import { vueReact } from "../react/pont.jsx";
import Profil from "../react/ecrans/Profil.jsx";

export { editerProfil } from "./profil-editer.js";

export const rendre = vueReact(Profil);
